import {Component, inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";

import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

import {InvoiceApiService} from "@numizmat/services/core";
import {InsertInvoiceRequest} from "@numizmat/services-models/core";
import {InvoicePaymentOptionApiService} from "@numizmat/services/nomenclature";
import {InvoicePaymentOptionResponse} from "@numizmat/services-models/nomenclature";

@Component({
  selector: 'nz-payment-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule
  ],
  templateUrl: './payment-modal.component.html',
  styleUrl: './payment-modal.component.scss'
})
export class PaymentModalComponent implements OnInit {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private invoiceApiService: InvoiceApiService = inject(InvoiceApiService);
  private invoicePaymentOptionApiService: InvoicePaymentOptionApiService = inject(InvoicePaymentOptionApiService);

  protected amountInput?: number;
  protected loading: boolean = false;
  protected form: FormGroup = this.initializeForm();
  protected invoicePaymentOptions: InvoicePaymentOptionResponse[] = [];

  public ngOnInit(): void {
    this.getAllInvoicePaymentOptions();
    if (!!this.amountInput && this.amountInput >= 1) {
      this.amount?.setValue(this.amountInput);
    }
  }

  protected onSubmit(): void {
    this.loading = true;
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      this.loading = false;
      return;
    }
    const formValue = this.form.getRawValue();
    const request: InsertInvoiceRequest = {
      amount: formValue.amount,
      invoicePaymentOptionId: formValue.invoicePaymentOptionId,
    };
    this.invoiceApiService.insertInvoice(request).subscribe({
      next: response => {
        this.closeModal();
        window.open(response.paymentUrl);
      }
    });
  }

  protected closeModal(): void {
    this.activeModal.dismiss();
  }

  private initializeForm() {
    return new FormGroup({
      amount: new FormControl(null, [Validators.required, Validators.min(1)]),
      invoicePaymentOptionId: new FormControl(100, [Validators.required])
    });
  }

  private getAllInvoicePaymentOptions(): void {
    this.invoicePaymentOptionApiService.getAllInvoicePaymentOptions().subscribe({
      next: response => {
        this.invoicePaymentOptions = response;
      }
    })
  }

  get amount() {
    return this.form.get('amount');
  }

  get invoicePaymentOptionId() {
    return this.form.get('invoicePaymentOptionId');
  }
}
